export default "__VITE_ASSET__db983237__"